export const ValidationUtils = {
  methods: {
    validateDate (newDate, question) {
      const re = /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/
      if (!re.test(newDate)) {
        this.errorDate = 'The Date Of Birth must be valid and in the format MM/dd/yyyy, should not be in the future and should not be before 1900'
      } else if (this.isFutureDate(newDate)) {
        this.errorDate = 'The Date Of Birth should not be in the future'
      } else if (this.isOldDate(newDate)) {
        this.errorDate = 'Date Of Birth should not be more than 120 years in the past'
      } else {
        this.errorDate = ''
      }
    },
    validateInsuredDate (newDate, question) {
      const re = /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/
      if (!re.test(newDate)) {
        this.errorInsuredDate = 'The Date Of Birth must be valid and in the format MM/dd/yyyy, should not be in the future and should not be before 1900'
      } else if (this.isFutureDate(newDate)) {
        this.errorInsuredDate = 'The Date Of Birth should not be in the future'
      } else if (this.isOldDate(newDate)) {
        this.errorInsuredDate = 'Date Of Birth should not be more than 120 years in the past'
      } else {
        this.errorInsuredDate = ''
      }
    },
    validateDateGuardian (newDate) {
      const re = /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/
      if (!re.test(newDate)) {
        this.error_guardian_dob = 'The Date Of Birth must be valid and in the format MM/dd/yyyy, should not be in the future and should not be before 1900'
      } else if (this.isFutureDate(newDate)) {
        this.error_guardian_dob = 'The Date Of Birth should not be in the future'
      } else if (this.isOldDate(newDate)) {
        this.error_guardian_dob = 'Date Of Birth should not be more than 120 years in the past'
      } else if (this.guardian_info) {
        let date1 = new Date(this.model.guardian_dob_pretty)
        var ageDifMs = Date.now() - date1
        var ageDate = new Date(ageDifMs)
        let ages = (Math.abs(ageDate.getUTCFullYear() - 1970))
        if (ages < 18) {
          this.error_guardian_dob = 'The age of the guardian must not be less than 18'
        } else {
          this.error_guardian_dob = ''
        }
      } else {
        this.errorDate = ''
      }
    },
    validateQuestionDate (newDate, question) {
      if (newDate !== '') {
        const re = /^(((0)[0-9])|((1)[0-2]))(\/)([0-2][0-9]|(3)[0-1])(\/)\d{4}$/
        if (!re.test(newDate)) {
          this.setQuestionInvalidStatus(newDate, question, 1, 'The Date must be valid and in the format MM/dd/yyyy')
        } else if (newDate.length === 10 && this.isFutureDate(newDate)) {
          this.setQuestionInvalidStatus(newDate, question, 1, 'The Date should not be in the future')
        } else if (newDate.length === 10 && this.isCustomMonthsOlder(newDate, 2)) {
          this.setQuestionInvalidStatus(newDate, question, 1, 'The Date cannot be older than 2 months')
        } else if (newDate.length === 10 && this.isOldDate(newDate)) {
          this.setQuestionInvalidStatus(newDate, question, 1, 'The Date should not be more than 120 years in the past')
        } else {
          this.setQuestionInvalidStatus(newDate, question, 0, '')
        }
      } else {
        this.questionErrorDate[question.id] = false
        this.$set(this.questionErrorDate, question.id, false)
        for (let q = 0; q < this.$store.state.questions.length; q++) {
          if (this.$store.state.questions[q].id === question.id) {
            this.$store.state.questions[q].answer = undefined
          }
        }
      }
    },
    setQuestionInvalidStatus (newDate, question, status, message) {
      message = message || ''
      if (question) {
        for (let q = 0; q < this.$store.state.questions.length; q++) {
          if (this.$store.state.questions[q].id === question.id) {
            if (status === 1) {
              this.$store.state.questions[q].answer = ' '
              this.questionErrorDate[question.id] = message
              this.$set(this.questionErrorDate, question.id, message)
            } else {
              if (typeof this.$store.state.questions[q].answer_pretty !== 'undefined') {
                let dateParts = this.$store.state.questions[q].answer_pretty.split('/')
                this.$store.state.questions[q].answer = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1]
              }
              this.questionErrorDate[question.id] = false
              this.$set(this.questionErrorDate, question.id, false)
            }
          }
        }
      }
    },
    isFutureDate (verifiedDate) {
      const today = new Date().getTime()
      let date = verifiedDate.split('/')
      date = new Date(date[2], date[0] - 1, date[1]).getTime()
      return (today - date) < 0
    },
    isOldDate (verifiedDate) {
      const today = new Date().getTime()
      let date = verifiedDate.split('/')
      date = new Date(date[2], date[0] - 1, date[1]).getTime()
      return (today - date) > 3786831116964
    },
    isCustomMonthsOlder (verifiedDate, months) {
      let pastDate = new Date()
      pastDate.setMonth(pastDate.getMonth() - parseInt(months))
      pastDate = pastDate.getTime()
      let date = verifiedDate.split('/')
      date = new Date(date[2], date[0] - 1, date[1]).getTime()
      return (pastDate > date)
    },
    /**
     * Custom Questions Validation Rules
     * @param question
       */
    registrationQuestionsValidation (question) {
      if (question.used_for === '1') {
        for (let q = 0; q < this.$store.state.questions.length; q++) {
          if (typeof this.$store.state.questions[q].clarification !== 'undefined' &&
              this.$store.state.questions[q].clarification !== null &&
              this.$store.state.questions[q].clarification === question.id &&
              (typeof this.$store.state.questions[q].answer === 'undefined' ||
              this.$store.state.questions[q].answer === null ||
              this.$store.state.questions[q].answer.toLowerCase() !== 'yes')) {
            return false
          }
        }
        return true
      }
    },
    /**
     *
     * Show the: "If yes, then date of symptom onset" question if "Symptomatic as defined by CDC?" 's answer is Yes
     * @returns {boolean}
       */
    showDateOfSymptomIfCDCIsYes (question) {
      question = question || false
      if (question && typeof question.name !== 'undefined') {
        return (question.name.toLowerCase())
      }
      return true
    },
    isMobile () {
      let check = false;
      (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os) ? |phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cm|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(a.substr(0, 4))) { check = true } })(navigator.userAgent || navigator.vendor || window.opera)
      return check
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/Validation.js